import { render } from "./ChatbotBox.vue?vue&type=template&id=57b4f8ac&scoped=true"
import script from "./ChatbotBox.vue?vue&type=script&lang=js"
export * from "./ChatbotBox.vue?vue&type=script&lang=js"

import "./ChatbotBox.vue?vue&type=style&index=0&id=57b4f8ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b4f8ac"]])

export default __exports__